import { Route, Routes } from 'react-router-dom';
import Index from './features/index/Index';
import CustomerInformation from './components/customerInformation/CustomerInformation';
import ComplaintRegistration from './components/complaintRegistration/ComplaintRegistration';
import { ComplaintSummary } from './components/complaintSummary/ComplaintSummary';
import StatusCheck from './components/statusCheck/StatusCheck';
import { getComplaintPositionComponents } from './features/complaintPositionsComponents/ComplaintPositionsComponentsSlice';
import { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SuccessfulComplaint from './components/successfulComplaint/SuccessfulComplaint';
import { CompanyInformation } from './components/companyInformation/CompanyInformation';
import { CompanyComplaintRegistration } from './components/companyComplaintRegistration/CompanyComplaintRegistration';
import { CustomerTypePage } from './components/customerTypePage/CustomerTypePage';
import CompanyReceiptGoods from './components/companyReceiptGoods/CompanyReceiptGoods';
import { CompanyComplaintSummary } from './components/companyComplaintSummary/companyComplaintSummary';
import { StatusCheckView } from './components/statusCheck/StatusCheckView';
import { useNavigate } from 'react-router-dom';
import { clearAllPositions } from './features/complaintPosition/ComplaintPositionSlice';


function App() {
const dispatch = useDispatch();
const navigate = useNavigate();
useEffect(()=>{
  dispatch(getComplaintPositionComponents())
},[dispatch])

useEffect(()=>{
  const handleKeyDown = (event) =>{
    if(event.keyCode === 116){
      event.preventDefault();
      navigate('/');
      dispatch(clearAllPositions());
      window.location.reload('/');

    }
  };
  document.addEventListener('keydown', handleKeyDown);
  return () =>{
    document.removeEventListener('keydown', handleKeyDown);
  }
},[navigate]);

useEffect(() => {
  const handlePopstate = () => {
    window.location.reload('/');
  };

  window.addEventListener('popstate', handlePopstate);
  return () => {
    window.removeEventListener('popstate', handlePopstate);
};
});

return (
  <div>
    <Routes>
        <Route path="/">
          <Route index  element={<Index/>}/>
        </Route>
        <Route path="/customers" element={<CustomerTypePage/>}/>
        <Route path='/information' element={<CustomerInformation/>}/>
        <Route path='/registration' element={<ComplaintRegistration/>}/>
        {/* <Route path='/receiptGoods' element={<ReceiptGoods/>}/> */}
        <Route path='/summary' element={<ComplaintSummary/>}/>
        <Route path='/status' element={<StatusCheck/>}/>
        <Route path='/send' element={<SuccessfulComplaint/>}/>
        {/* FIRMA */}
        <Route path='/companySearch' element={<CompanyInformation/>}/>
        <Route path='/companyRegistration' element={<CompanyComplaintRegistration/>}/>
        <Route path='/companyReceiptGoods' element={<CompanyReceiptGoods/>}/>
        <Route path='/companySummary' element={<CompanyComplaintSummary/>}/>
        <Route path='/statusCheck' element={<StatusCheckView/>}/>
    </Routes>
    </div>
  )
}

export default App;